import React, { useEffect, useState } from "react";
import { goTo } from "../../App";

export default function StickyCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="md:hidden"
      style={{
        position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 60,
        transform: show ? "translateY(0)" : "translateY(120%)",
        transition: "transform 0.28s ease",
        background: "rgba(1,7,26,0.96)", backdropFilter: "blur(8px)",
        padding: "10px 16px calc(10px + env(safe-area-inset-bottom))",
        borderTop: "1px solid var(--line)",
      }}
    >
      <button onClick={() => goTo("live")} className="btn btn-blue w-full">
        Prenota il posto alla live
      </button>
    </div>
  );
}
